import { motion } from "framer-motion";
import { TESTIMONIALS } from "@/lib/site";
import { Quote, Star } from "lucide-react";

export default function Testimonials() {
  return (
    <section
      id="depoimentos"
      data-testid="testimonials-section"
      className="py-24 md:py-36 bg-[#F7F7F5] relative overflow-hidden"
    >
      <div className="max-w-7xl mx-auto px-6 md:px-12 relative">
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-10 mb-14 md:mb-20">
          <div className="lg:col-span-6">
            <p className="text-[11px] tracking-[0.3em] uppercase text-neutral-500 mb-6 flex items-center gap-3">
              <span className="inline-block h-px w-10 bg-neutral-400" />
              Depoimentos
            </p>
            <h2 className="font-serif font-light text-4xl sm:text-5xl lg:text-6xl leading-[1.05] tracking-tight text-black">
              O que dizem as <em className="italic">minhas clientes.</em>
            </h2>
          </div>
          <div className="lg:col-span-5 lg:col-start-8 self-end">
            <div className="flex items-center gap-3 mb-3">
              {[0, 1, 2, 3, 4].map((i) => (
                <Star
                  key={i}
                  className="h-4 w-4 fill-black text-black"
                  strokeWidth={1.2}
                />
              ))}
              <span className="text-[10px] tracking-[0.25em] uppercase text-neutral-500 ml-2">
                5,0 · Google Reviews
              </span>
            </div>
            <p className="text-sm md:text-base text-neutral-600 leading-relaxed max-w-md">
              Cada palavra abaixo é de uma cliente que confiou no meu trabalho.
              Obrigada pela partilha.
            </p>
          </div>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-6 md:gap-8">
          {TESTIMONIALS.map((t, i) => (
            <motion.figure
              key={t.name}
              initial={{ opacity: 0, y: 30 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, margin: "-60px" }}
              transition={{ duration: 0.8, delay: i * 0.08, ease: "easeOut" }}
              className="relative bg-white border border-black/10 hover:border-black transition-colors duration-500 p-8 md:p-10 flex flex-col"
              data-testid={`testimonial-${i}`}
            >
              <Quote
                className="h-8 w-8 text-black/15 mb-6"
                strokeWidth={1}
                aria-hidden="true"
              />
              <blockquote className="font-serif italic text-lg md:text-xl leading-relaxed text-neutral-800 font-light flex-1">
                &ldquo;{t.text}&rdquo;
              </blockquote>
              <figcaption className="mt-8 pt-6 border-t border-black/10 flex items-center justify-between">
                <div>
                  <div className="text-[10px] tracking-[0.3em] uppercase text-neutral-500">
                    Cliente
                  </div>
                  <div className="mt-1 text-base text-black">{t.name}</div>
                </div>
                <div className="flex items-center gap-1">
                  {[0, 1, 2, 3, 4].map((s) => (
                    <Star
                      key={s}
                      className="h-3.5 w-3.5 fill-black text-black"
                      strokeWidth={1.2}
                    />
                  ))}
                </div>
              </figcaption>
            </motion.figure>
          ))}
        </div>
      </div>
    </section>
  );
}
